// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.shift-activity[data-v-07fd3031] {\n  border-left: 1px rgb(190, 190, 190) solid;\n  width: 30%;\n  text-align: center;\n}\n.shift-activity-name[data-v-07fd3031] {\n  border-left: 1px rgb(190, 190, 190) solid;\n  width: 100%;\n  text-align: center;\n}\n.shift-activity-comment[data-v-07fd3031] {\n  border-left: 1px rgb(190, 190, 190) solid;\n  width: 100%;\n  text-align: center;\n}\n\n", ""]);
// Exports
module.exports = exports;
